<div class="row row--primary">
  @if (model?.directive) {
    <div class="tile">
      <div class="col-12 text-center bezugsrecht-success-check">
        <ng-lottie [options]="options" />
      </div>
      <div class="col-12 text-center mb-4">
        <h1 class="zero-text p-huge-med">
          {{ 'bezugsrecht-page.bezugsrecht-success.hint' | transloco }}
        </h1>
      </div>
      <div class="col-12 text-center mb-4">
        <div class="row">
          <div class="col-12">
            {{
              'bezugsrecht-page.bezugsrecht-success.subscription'
                | transloco
                  : {
                      amountShares: model.directive.bezugAktien,
                      underlyingName: model.directive.bezugAktieBezeichnung,
                      underlyingIsin: model.directive.bezugAktieIsin,
                    }
            }}
          </div>
          @if (model.directive.bezugBzr) {
            <div class="col-12 mt-2">
              {{
                'bezugsrecht-page.bezugsrecht-success.remaining-buy'
                  | transloco
                    : {
                        amount: model.directive.bezugBzr,
                        name: model.directive.bzrBezeichnung,
                        isin: model.directive.bzrIsin,
                      }
              }}
            </div>
          } @else {
            @if (model.directive.verkaufBzr) {
              <div class="col-12 mt-2">
                {{
                  'bezugsrecht-page.bezugsrecht-success.remaining-sell'
                    | transloco
                      : {
                          amount: model.directive.verkaufBzr,
                          name: model.directive.bzrBezeichnung,
                          isin: model.directive.bzrIsin,
                        }
                }}
              </div>
            }
          }
          <div class="col-12 mt-2">
            {{
              'bezugsrecht-page.bezugsrecht-success.price-hint'
                | transloco
                  : {
                      price: model.directive.bezugAktienWertSumme | currency: 'EUR' : 'symbol' : '1.2',
                      dueDate: model.directive.bezugAktienTermin | date: 'shortDate',
                    }
            }}
          </div>
          <div class="col-12 mt-2">
            {{
              'bezugsrecht-page.bezugsrecht-success.valuta-hint'
                | transloco
                  : {
                      date: model.directive.bezugAktienTermin | date: 'shortDate',
                    }
            }}
          </div>
          <div class="col-12 mt-2">
            {{ 'bezugsrecht-page.bezugsrecht-success.end-note' | transloco }}
          </div>
        </div>
      </div>
      <div class="col-12 d-flex justify-content-center">
        <web-design-system-button type="secondary" [routerLink]="commonRoutes.postlogin.member_home">
          {{ 'bezugsrecht-page.bezugsrecht-success.to-depot' | transloco }}
        </web-design-system-button>
      </div>
    </div>
  }
</div>
